import { TravelRestrictionsLine } from 'Components/lines/travel-restrictions-line/TravelRestrictionsLine';
export default TravelRestrictionsLine;
